// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.qx9vyy_TOVJXbO {
  display: flex;
  align-items: center;
  width: 100%;
  gap: var(--ds-space-100, 8px);
}
.qx9vyy_TOVJXbO.H7I1tAwGZtU6f0 {
  width: unset;
  padding: var(--ds-space-150, 12px) var(--ds-space-150, 12px) var(--ds-space-0, 0) var(--ds-space-150, 12px);
}
.lS7rHKsAnpFhWk {
  position: relative;
  flex: 1;
}
.xYZh9LM5_fZPfT {
  width: 100%;
}
.e2BxJjOnaBJ4QP {
  position: absolute;
  top: var(--ds-space-050, 4px);
  right: var(--ds-space-050, 4px);
  height: 28px;
  padding: var(--ds-space-050, 4px);
  border: none;
  background: none;
}
`, ""]);
// Exports
export var container = `qx9vyy_TOVJXbO`;
export var panel = `H7I1tAwGZtU6f0`;
export var search = `lS7rHKsAnpFhWk`;
export var searchInput = `xYZh9LM5_fZPfT`;
export var clearButton = `e2BxJjOnaBJ4QP`;
export default ___CSS_LOADER_EXPORT___;
